import { HttpRepository } from '@/modules/shared/shared/domain/repositories/http.repository';
class MaintenanceReport extends HttpRepository {
    private static readonly RESOURCE = 'maintance-reports';
    getAll(location = 'CARACAS') {
        return this.get(
            this.createUri(['maintenance-reports'], { location }),
            this.createAuthorizationHeader(),
        );
    }

    getReport(file: string, location: string) {
        return this.get(
            this.createUri(['maintenance-reports', file], { location }),
            this.createAuthorizationDocumentsHeader(),
        );
    }

    uploadReport(data: { date: string; formData: any }) {
        return this.post(
            this.createUri(['maintenance-reports', 'CARACAS', `${data.date}`]),
            data.formData,
            this.createAuthorizationHeader(),
        );
    }
}

export const maintenanceReportRepository = new MaintenanceReport();
